export default __webpack_public_path__ + "9e30c9c9e8a2aaaa193b2843a677e035.svg";